<template>
    <div class="row">

        <div class="col-lg-9">

            <div class="card card-bordered">
                <div class="card-inner">

                    <!-- Pilot stuff -->
                    <div class="row gy-gs pb-3">
                        <div class="col">

                            <!-- Add an plus button to add more peeps -->
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{{ translations.pilot }}</h3>
                                    </div>
                                    <div class="nk-block-head-content">
                                        <a href="javascript:void(0)" class="btn btn-primary"
                                           @click.prevent="createPilot">
                                            <em class="icon ni ni-plus"></em>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="pilots.length">
                                <!-- List the existing pilots here -->
                                <div class="row g-gs pb-3">
                                    <div
                                        class="col-sm-6 col-lg-4 col-xxl-3"
                                        v-for="pilot in pilots"
                                        :key="pilot.id"
                                    >
                                        <div class="card card-bordered" style="min-height: 235px;max-height: 235px;">
                                            <div class="card-inner">
                                                <div class="team">
                                                    <div v-if="registration.pilot_id === pilot.id"
                                                         class="team-status bg-success text-white">
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div v-else class="team-status bg-light text-black">
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div class="team-options">
                                                        <div class="drodown">
                                                            <a href="#"
                                                               class="dropdown-toggle btn btn-sm btn-icon btn-trigger"
                                                               data-toggle="dropdown" aria-expanded="false">
                                                                <em class="icon ni ni-more-h"></em>
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right" style="">
                                                                <ul class="link-list-opt no-bdr">
                                                                    <li>
                                                                        <a href="javascript:void(0)"
                                                                           @click="editCompetitor(pilot)">
                                                                            <em class="icon ni ni-edit"></em><span>{{
                                                                                translations.edit
                                                                            }}</span>
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0)"
                                                                           @click="deleteCompetitor(pilot, index)">
                                                                            <em class="icon ni ni-trash"></em><span>{{
                                                                                translations.delete
                                                                            }}</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="user-card user-card-s2">
                                                        <div class="user-info">
                                                            <h6>{{ pilot.firstname }} {{ pilot.lastname }}</h6>
                                                        </div>
                                                    </div>
                                                    <div class="team-details">
                                                        <p>{{ pilot.street }} {{ pilot.number }}, {{ pilot.zipcode }}
                                                            {{ pilot.city }}</p>
                                                    </div>
                                                    <div class="team-view mt-3">
                                                        <a href="javascript:void(0)"
                                                           class="btn btn-round btn-outline-light w-150px"
                                                           @click="selectPilot($event, pilot)"
                                                        >
                                                            <span>{{ translations.select }}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div v-else>
                                <div class="row g-gs pb-3">
                                    <div class="col">
                                        <p>{{ translations.pilots_empty }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Copilot stuff -->
                    <div class="row gy-gs pb-3">
                        <div class="col">

                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{{ translations.copilot }}</h3>
                                    </div>
                                    <div class="nk-block-head-content">
                                        <a href="javascript:void(0)" class="btn btn-primary"
                                           @click.prevent="createCopilot">
                                            <em class="icon ni ni-plus"></em>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="copilots.length">
                                <!-- List the existing pilots here -->
                                <div class="row g-gs pb-3">
                                    <div
                                        class="col-sm-6 col-lg-4 col-xxl-3"
                                        v-for="copilot in copilots"
                                        :key="copilot.id"
                                    >
                                        <div class="card card-bordered" style="min-height: 235px;max-height: 235px;">
                                            <div class="card-inner">
                                                <div class="team">
                                                    <div
                                                        v-if="registration.copilot_id === copilot.id"
                                                        class="team-status bg-success text-white"
                                                    >
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div v-else class="team-status bg-light text-black">
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div class="team-options">
                                                        <div class="drodown">
                                                            <a href="#"
                                                               class="dropdown-toggle btn btn-sm btn-icon btn-trigger"
                                                               data-toggle="dropdown" aria-expanded="false">
                                                                <em class="icon ni ni-more-h"></em>
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right" style="">
                                                                <ul class="link-list-opt no-bdr">
                                                                    <li>
                                                                        <a href="javascript:void(0)"
                                                                           @click="editCompetitor(copilot)">
                                                                            <em class="icon ni ni-edit"></em><span>{{
                                                                                translations.edit
                                                                            }}</span>
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0)"
                                                                           @click="deleteCompetitor(copilot, index)">
                                                                            <em class="icon ni ni-trash"></em><span>{{
                                                                                translations.delete
                                                                            }}</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="user-card user-card-s2">
                                                        <div class="user-info">
                                                            <h6>{{ copilot.firstname }} {{ copilot.lastname }}</h6>
                                                        </div>
                                                    </div>
                                                    <div class="team-details">
                                                        <p>{{ copilot.street }} {{ copilot.number }}, {{
                                                                copilot.zipcode
                                                            }}
                                                            {{ copilot.city }}</p>
                                                    </div>
                                                    <div class="team-view mt-3">
                                                        <a href="javascript:void(0)"
                                                           class="btn btn-round btn-outline-light w-150px"
                                                           @click="selectCopilot($event, copilot)">
                                                            <span>{{ translations.select }}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div v-else>
                                <div class="row g-gs pb-3">
                                    <p>{{ translations.copilots_empty }}</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Vehicle stuff -->
                    <div class="row gy-gs pb-3">
                        <div class="col">

                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{{ translations.vehicle }}</h3>
                                    </div>
                                    <div class="nk-block-head-content">
                                        <a href="javascript:void(0)" class="btn btn-primary" @click="createVehicle()">
                                            <em class="icon ni ni-plus"></em>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="user_vehicles.length">
                                <!-- List the existing pilots here -->
                                <div class="row g-gs pb-3">
                                    <div
                                        class="col-sm-6 col-lg-4 col-xxl-3"
                                        v-for="(vehicle, index) in user_vehicles"
                                        :key="vehicle.id"
                                    >
                                        <div class="card card-bordered" style="min-height: 235px;max-height: 235px;">
                                            <div class="card-inner">
                                                <div class="team">
                                                    <div v-if="registration.vehicle_id === vehicle.id"
                                                         class="team-status bg-success text-white">
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div v-else class="team-status bg-light text-black">
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div class="team-options">
                                                        <div class="drodown">
                                                            <a href="#"
                                                               class="dropdown-toggle btn btn-sm btn-icon btn-trigger"
                                                               data-toggle="dropdown" aria-expanded="false">
                                                                <em class="icon ni ni-more-h"></em>
                                                            </a>
                                                            <div class="dropdown-menu dropdown-menu-right" style="">
                                                                <ul class="link-list-opt no-bdr">
                                                                    <li>
                                                                        <a href="javascript:void(0)"
                                                                           @click="editVehicle(vehicle)">
                                                                            <em class="icon ni ni-edit"></em><span>{{
                                                                                translations.edit
                                                                            }}</span>
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="javascript:void(0)"
                                                                           @click="deleteVehicle(vehicle, index)">
                                                                            <em class="icon ni ni-trash"></em><span>{{
                                                                                translations.delete
                                                                            }}</span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="user-card user-card-s2">
                                                        <!--                                            <div class="user-avatar md bg-primary">-->
                                                        <!--                                                <img src="/demo6/images/avatar/a-sm.jpg" alt="">-->
                                                        <!--                                            </div>-->
                                                        <div class="user-info">
                                                            <h6>{{ vehicle.brand }} {{ vehicle.type }}</h6>
                                                        </div>
                                                    </div>
                                                    <div class="team-details">
                                                        <p>{{ vehicle.license_plate }} <span v-if="vehicle.build_year">({{
                                                                vehicle.build_year
                                                            }})</span></p>
                                                    </div>
                                                    <div class="team-view mt-3">
                                                        <a
                                                            class="btn btn-round btn-outline-light w-150px"
                                                            @click.prevent="selectVehicle($event, vehicle)"
                                                        >
                                                            <span>{{ translations.select }}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div v-else>
                                <div class="row g-gs pb-3">
                                    <p>{{ translations.vehicles_empty }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- difficulty stuff -->
                    <div class="row gy-gs pb-3">
                        <div class="col">

                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{{ translations.difficulty }}</h3>
                                    </div>
                                </div>
                            </div>

                            <div v-if="difficulties.length">
                                <!-- List the difficulties here -->
                                <div class="row g-gs pb-3">
                                    <div
                                        class="col-sm-6 col-lg-4 col-xxl-3"
                                        v-for="(difficulty, index) in difficulties"
                                        :key="difficulty.place"
                                    >
                                        <div class="card card-bordered" style="min-height: 235px;max-height: 235px;">
                                            <div class="card-inner">
                                                <div class="team">
                                                    <div
                                                        v-if="registration.difficulty === difficulty.name"
                                                        class="team-status bg-success text-white"
                                                    >
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div v-else class="team-status bg-light text-black">
                                                        <em class="icon ni ni-check-thick"></em>
                                                    </div>
                                                    <div class="user-card user-card-s2">
                                                        <div class="user-info">
                                                            <h6>{{ difficulty.name }}</h6>
                                                        </div>
                                                    </div>
                                                    <div class="team-details">
                                                        <p>{{ difficulty.description }}</p>
                                                    </div>
                                                    <div class="team-view mt-3">
                                                        <a href="javascript:void(0)"
                                                           class="btn btn-round btn-outline-light w-150px"
                                                           @click="selectDifficulty($event, difficulty)">
                                                            <span>{{ translations.select }}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div v-else>
                                <div class="row g-gs pb-3">
                                    <p>{{ translations.difficulties_empty }}</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- catering stuff -->
                    <div v-if="event_catering.length" class="row gy-gs pb-3">
                        <div class="col">

                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{{ translations.catering }}</h3>
                                    </div>
                                </div>
                            </div>

                            <div v-if="event_catering.length">
                                <!-- List the catering items here -->
                                <div class="row g-gs pb-3">
                                    <div
                                        class="col-sm-6 col-lg-4 col-xxl-3"
                                        v-for="(catering, index) in event_catering"
                                        :key="catering.id"
                                    >
                                        <div class="card card-bordered">

                                            <img v-if="catering.imageUrl !== ''" :src="catering.imageUrl"
                                                 class="card-img-top"
                                                 style="max-height: 158px;min-height: 158px;object-fit: cover;"
                                                 :alt="catering.name">

                                            <div class="card-inner">
                                                <div class="team">

                                                    <div class="user-card user-card-s2">
                                                        <div class="user-info">
                                                            <h6>{{ catering.name }}</h6>
                                                            <small
                                                                v-html="formatPrice(catering.sell_price) + '/pp.'"></small>
                                                        </div>
                                                    </div>
                                                    <div class="team-details">
                                                        <p>{{ catering.description }}</p>
                                                        <div class="form-group">
                                                            <label
                                                                class="form-label"
                                                                v-text="translations.forms.catering.select_amount"
                                                            ></label>
                                                            <div class="form-control-wrap">
                                                                <div class="form-control-select">
                                                                    <select
                                                                        class="form-control catering-selector"
                                                                        @change="updateCateringSelectedValue"
                                                                    >
                                                                        <option
                                                                            v-for="amount in 3"
                                                                            :key="(amount - 1)"
                                                                            :data-catering="JSON.stringify(catering)"
                                                                            :value="(amount - 1)"
                                                                        >{{ (amount - 1) }}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- THE PRICES SIDEBAR -->
        <div class="col-lg-3">
            <div class="card card-bordered sticky-top ml-lg-4 ml-xl-0">

                <div class="nk-iv-wg4">
                    <div class="nk-iv-wg4-sub">
                        <h6 class="nk-iv-wg4-title title">{{ translations.sidebar.title }}</h6>
                    </div>
                    <div class="nk-iv-wg4-sub">
                        <ul class="nk-iv-wg4-list">
                            <li>
                                <div class="sub-text">{{ translations.sidebar.payment_method }}</div>
                                <div class="lead-text">{{ translations.sidebar.payment_method_value }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="nk-iv-wg4-sub">
                        <ul class="nk-iv-wg4-list">
                            <li>
                                <div class="sub-text">{{ translations.sidebar.registration }}</div>
                                <div class="lead-text" v-html="formatPrice(event.price)"></div>
                            </li>
                            <li>
                                <div class="sub-text">{{ translations.sidebar.day_license_pilot }}</div>
                                <div class="lead-text" v-html="formatPrice(getPilotDayLicensePrice)"></div>
                            </li>
                            <li>
                                <div class="sub-text">{{ translations.sidebar.day_license_copilot }}</div>
                                <div class="lead-text" v-html="formatPrice(getCopilotDayLicensePrice)"></div>
                            </li>
                            <li v-if="event_catering.length">
                                <div class="sub-text">{{ translations.sidebar.catering }}</div>
                                <div class="lead-text" v-html="formatPrice(getCateringPrices)"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="nk-iv-wg4-sub">
                        <ul class="nk-iv-wg4-list">
                            <li>
                                <div class="lead-text">{{ translations.sidebar.total_amount }}</div>
                                <div class="caption-text text-primary" v-html="formatPrice(getTotalAmountToPay)"></div>
                            </li>
                        </ul>
                    </div>
                    <div class="nk-iv-wg4-sub text-center bg-lighter">
                        <!-- Show modal that is being build to pay (the QR code build and a button 'or use your bank account') -->
                        <a href="#" class="btn btn-lg btn-primary ttu" :class="getCanContinueToPayment"
                           data-toggle="modal"
                           data-target="#payModal">{{ translations.sidebar.config_and_proceed }}</a>
                    </div>
                </div>

            </div>
        </div>

        <!-- MODALS -->
        <add-pilot-modal
            v-if="showPilotAddModal"
            :translations="translations"
            @onSave="addPilotObject"
            @closeModal="showPilotAddModal = false"
        ></add-pilot-modal>

        <add-copilot-modal
            v-if="showCopilotAddModal"
            :translations="translations"
            @onSave="addCopilotObject"
            @closeModal="showCopilotAddModal = false"
        ></add-copilot-modal>

        <add-vehicle-modal
            v-if="showVehicleAddModal"
            :translations="translations"
            @onSave="addVehicleObject"
            @closeModal="showVehicleAddModal = false"
        ></add-vehicle-modal>

        <edit-competitor-modal
            v-if="showCompetitorEditModal"
            :competitor="competitor"
            :translations="translations"
            @onSave="saveCompetitor"
            @closeModal="showCompetitorEditModal = false"
        ></edit-competitor-modal>

        <delete-competitor-modal
            v-if="showCompetitorDeleteModal"
            :competitor="competitor"
            :translations="translations"
            @onDelete="removeCompetitor"
            @closeModal="showCompetitorDeleteModal = false"
        ></delete-competitor-modal>

        <edit-vehicle-modal
            v-if="showVehicleEditModal"
            :vehicle="vehicle"
            :translations="translations"
            @onSave="saveVehicle"
            @closeModal="showVehicleEditModal = false"
        ></edit-vehicle-modal>

        <delete-vehicle-modal
            v-if="showVehicleDeleteModal"
            :vehicle="vehicle"
            :translations="translations"
            @onDelete="removeVehicle"
            @closeModal="showVehicleDeleteModal = false"
        ></delete-vehicle-modal>
    </div>
</template>

<script>

import editCompetitorModal from './modals/editCompetitorModal'
import deleteCompetitorModal from './modals/deleteCompetitorModal'
import editVehicleModal from './modals/editVehicleModal'
import deleteVehicleModal from './modals/deleteVehicleModal'
import addPilotModal from './modals/addPilotModal'
import addCopilotModal from './modals/addCopilotModal'
import addVehicleModal from './modals/addVehicleModal'

export default {
    name: 'registrationForm',
    components: {
        addPilotModal,
        addCopilotModal,
        addVehicleModal,
        editCompetitorModal,
        deleteCompetitorModal,
        editVehicleModal,
        deleteVehicleModal,
    },

    props: [
        'user_pilots',
        'user_copilots',
        'user_vehicles',
        'difficulties',
        'event_catering',
        'user_registration',
        'event',
        'translations',
    ],

    data() {
        return {
            competitor: null,
            vehicle: null,
            pilots: this.user_pilots,
            copilots: this.user_copilots,
            registration: this.user_registration,
            showCompetitorEditModal: false,
            showCompetitorDeleteModal: false,
            showVehicleDeleteModal: false,
            showVehicleEditModal: false,
            showPilotAddModal: false,
            showCopilotAddModal: false,
            showVehicleAddModal: false,
            cateringPrice: 0.0,
        }
    },

    computed: {
        getCateringPrices() {
            return this.registration.totalCateringAmount ?? 0
        },

        getPilotDayLicensePrice() {
            if (!this.pilot) {
                return 0
            }

            return this.registration.pilot?.day_license ? this.event.day_license_price : 0.0
        },
        getCopilotDayLicensePrice() {
            if (!this.copilot) {
                return 0
            }

            return this.registration.copilot?.day_license ? this.event.day_license_price : 0.0
        },

        getCanContinueToPayment: function () {
            return {
                disabled: !this.registration.pilot_id || !this.registration.copilot_id || !this.registration.vehicle_id || this.registration.difficulty === 'None'
            }
        },

        getTotalAmountToPay() {
            return this.getCateringPrices ?? 0 + this.event.price + this.getPilotDayLicensePrice + this.getCopilotDayLicensePrice
        },
    },

    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')

            return '&euro; ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        selectPilot(e, pilot) {
            // Reset all the statuses of the visuals to be not checked
            $(e.currentTarget).parents().eq(5).find('.team-status').removeClass('bg-success')
                .removeClass('text-white')
                .addClass('bg-light')
                .addClass('text-black')

            $(e.currentTarget).parents().eq(1).find('.team-status')
                .removeClass('bg-light').removeClass('text-black')
                .addClass('bg-success').addClass('text-white')

            axios.post('/api/internal/events/registration/update-pilot', {
                registration_id: parseInt(REGISTRATION_ID),
                event_id: this.event.id,
                user_id: parseInt(USER_ID),
                pilot_id: pilot.id,
            }).then(({data}) => {
                NioApp.Toast(data, 'success', {position: 'top-right', timeOut: 5000})

                // Update the copilot on the registration, we replace the registration object here,
                // so Vue will pick up on the change and then update our computed properties.
                this.registration = {
                    ...this.registration,
                    pilot,
                }
            }).catch((errors) => {
                console.log(errors)
            })
        },
        selectCopilot(e, copilot) {
            // Reset all the statuses of the visuals to be not checked
            $(e.currentTarget).parents().eq(5).find('.team-status').removeClass('bg-success')
                .removeClass('text-white')
                .addClass('bg-light')
                .addClass('text-black')

            $(e.currentTarget).parents().eq(1).find('.team-status')
                .removeClass('bg-light').removeClass('text-black')
                .addClass('bg-success').addClass('text-white')

            axios.post('/api/internal/events/registration/update-copilot', {
                registration_id: parseInt(REGISTRATION_ID),
                event_id: this.event.id,
                user_id: parseInt(USER_ID),
                copilot_id: copilot.id,
            }).then(({data}) => {
                NioApp.Toast(data, 'success', {position: 'top-right', timeOut: 5000})

                // Update the copilot on the registration, we replace the registration object here,
                // so Vue will pick up on the change and then update our computed properties.
                this.registration = {
                    ...this.registration,
                    copilot,
                }
            }).catch((errors) => {
                console.log(errors)
            })
        },
        selectVehicle(e, vehicle) {
            // Reset all the statuses of the visuals to be not checked
            $(e.currentTarget).parents().eq(5).find('.team-status').removeClass('bg-success')
                .removeClass('text-white')
                .addClass('bg-light')
                .addClass('text-black')

            $(e.currentTarget).parents().eq(1).find('.team-status')
                .removeClass('bg-light').removeClass('text-black')
                .addClass('bg-success').addClass('text-white')

            axios.post('/api/internal/events/registration/update-vehicle', {
                registration_id: parseInt(REGISTRATION_ID),
                event_id: this.event.id,
                user_id: parseInt(USER_ID),
                vehicle_id: vehicle.id,
            }).then(({data}) => {
                NioApp.Toast(data, 'success', {position: 'top-right', timeOut: 5000})

                // Update the vehicle on the registration, we replace the registration object here,
                // so Vue will pick up on the change and then update our computed properties.
                this.registration = {
                    ...this.registration,
                    vehicle,
                }
            }).catch((errors) => {
                console.log(errors)
            })
        },
        selectDifficulty(e, difficulty) {
            // Reset all the statuses of the visuals to be not checked
            $(e.currentTarget).parents().eq(5).find('.team-status').removeClass('bg-success')
                .removeClass('text-white')
                .addClass('bg-light')
                .addClass('text-black')

            $(e.currentTarget).parents().eq(1).find('.team-status')
                .removeClass('bg-light').removeClass('text-black')
                .addClass('bg-success').addClass('text-white')

            axios.post('/api/internal/events/registration/update-difficulty', {
                registration_id: parseInt(REGISTRATION_ID),
                event_id: this.event.id,
                user_id: parseInt(USER_ID),
                difficulty: difficulty.name,
            }).then((response) => {
                NioApp.Toast(response.data, 'success', {position: 'top-right', timeOut: 5000})

                // Update the property
                this.registration.difficulty = difficulty.name;

            }).catch((errors) => {
                console.log(errors)
            })
        },

        /**
         * Shows the modal
         **/
        editCompetitor(competitor) {
            this.competitor = competitor
            this.showCompetitorEditModal = true
        },

        /**
         * Saves the data to the DB
         * @param competitor
         */
        saveCompetitor(competitor) {
            competitor.user_id = USER_ID

            axios.post('/api/internal/events/registration/update-competitor', competitor)
                .then(({data}) => {
                    NioApp.Toast(data.message, 'success', {
                        position: 'top-right',
                        timeOut: 5000
                    })

                    this.showCompetitorEditModal = false

                    const {competitor} = data;

                    // update our local copy of the copilots
                    this.copilots = this.copilots.map((copilot) => {
                        if (copilot.id === competitor.id) {
                            return competitor;
                        }

                        return copilot;
                    })

                    // Update our copilot on the registration, if he matches.
                    if (this.registration?.copilot?.id === competitor.id) {
                        this.registration = {
                            ...this.registration,
                            copilot: data.competitor,
                        }
                    }

                    // update our local copy of the pilots
                    this.pilots = this.pilots.map((pilot) => {
                        if (pilot.id === competitor.id) {
                            return competitor;
                        }

                        return pilot;
                    })

                    // Update our pilot on the registration, if he matches.
                    if (this.registration?.pilot?.id === competitor.id) {
                        this.registration = {
                            ...this.registration,
                            pilot: data.competitor,
                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        deleteCompetitor(competitor, index) {
            this.competitor = competitor
            this.competitor.compIndex = index
            this.showCompetitorDeleteModal = true
        },
        removeCompetitor(data) {
            data.user_id = USER_ID

            axios.post('/api/internal/events/registration/delete-competitor', data)
                .then((response) => {
                    NioApp.Toast(response.data.message, 'success', {position: 'top-right', timeOut: 5000})
                    if (data.type === 'pilot') {
                        this.$delete(this.pilots, data.compIndex)
                    } else {
                        this.$delete(this.copilots, data.compIndex)
                    }
                    this.showCompetitorDeleteModal = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        editVehicle(vehicle) {
            this.vehicle = vehicle
            this.showVehicleEditModal = true
        },
        deleteVehicle(vehicle, index) {
            this.vehicle = vehicle
            this.vehicle.vehIndex = index
            this.showVehicleDeleteModal = true
        },
        saveVehicle(data) {
            data.user_id = USER_ID

            axios.post('/api/internal/events/registration/update-vehicle-data', data)
                .then((response) => {
                    NioApp.Toast(response.data.message, 'success', {position: 'top-right', timeOut: 5000})

                    this.showVehicleEditModal = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        removeVehicle(data) {
            data.user_id = USER_ID

            axios.post('/api/internal/events/registration/delete-vehicle', data)
                .then((response) => {
                    NioApp.Toast(response.data.message, 'success', {position: 'top-right', timeOut: 5000})
                    this.$delete(this.user_vehicles, data.vehIndex)
                    this.showVehicleDeleteModal = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        createPilot() {
            this.showPilotAddModal = true
        },
        createCopilot() {
            this.showCopilotAddModal = true
        },
        createVehicle() {
            this.showVehicleAddModal = true
        },

        addPilotObject(pilot) {
            this.pilots.push(pilot)
            this.showPilotAddModal = false
        },
        addCopilotObject(copilot) {
            this.copilots.push(copilot)
            this.showCopilotAddModal = false
        },
        addVehicleObject(vehicle) {
            this.user_vehicles.push(vehicle)
            this.showVehicleAddModal = false
        },

        updateCateringSelectedValue(event) {
            let selectedCateringItem = JSON.parse(event.target.options[event.target.options.selectedIndex].dataset.catering)

            // do the magic to not allow more than 2 in total of selected items
            // $('.catering-selector').each(function () {
            //     let cateringItemId = $(this).find('option:selected').data('catering').id
            //     console.log(cateringItemId)
            //     console.log($(this).val())
            // });

            axios.post('/api/internal/events/registration/update-catering', {
                registration_id: parseInt(REGISTRATION_ID),
                event_id: this.event.id,
                user_id: parseInt(USER_ID),
                catering_item_id: selectedCateringItem.id,
                amount: event.target.value,
            }).then((response) => {

                this.cateringPrice = response.data.totalCateringAmount

                NioApp.Toast(response.data.message, 'success', {position: 'top-right', timeOut: 5000})
            }).catch((errors) => {
                console.log(errors)
            })
        },
    },
}

// Example for the selects;
// https://sfc.vuejs.org/#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
</script>
